import FlowGrid from '@/components/FlowGrid/index.vue';
import Banner from '@/components/Banner2';
import Cases from '@/components/Cases/index.vue';
import SmartCard from '@/components/SmartCard';
import SmartTitle from '@/components/SmartTitle';
import Appointment2 from '@/components/Appointment2/index.vue';
export default {
  components: {
    FlowGrid,
    Banner,
    Cases,
    SmartCard,
    SmartTitle,
    Appointment2
  },
  data() {
    return {
      bannerUrl: require('@/assets/images/service/customer-service/customerServiceBot-banner.png'),
      effectives: [{
        title: '全天候服务',
        desc: '7*24小时随时待命',
        icon: require('@/assets/images/service/customer-service/cs-robot/shiduan.png')
      }, {
        title: '提高服务效率',
        desc: '90%以上重复问题直接解决',
        icon: require('@/assets/images/service/customer-service/cs-robot/xiaolv.png')
      }, {
        title: '降低维护成本',
        desc: '自行学习用户问题',
        icon: require('@/assets/images/service/customer-service/cs-robot/chengben.png')
      }],
      skills: [{
        items: [{
          title: '全渠道接入',
          desc: '支持单平台多渠道接入，对接客户微信、APP、官网等。'
        }, {
          title: '知识管理',
          desc: '支持单平台多渠道接入，对接客户微信、APP、官网等。'
        }]
      }, {
        items: [{
          title: '全渠道报表',
          desc: '全渠道、多维度图形化报表统计，展示接待服务指标，热门问句分类统计。'
        }]
      }, {
        items: [{
          title: '动态答案',
          desc: '对接客户系统接口，部分问题调取接口获取相关数据，组合答案反馈给用户。'
        }, {
          title: '功能直达',
          desc: '通过口语指令，直接打开APP内的功能页面，绕过复杂的产品路径，一步直达。'
        }]
      }, {
        items: [{
          title: '自主学习',
          desc: '通过与线上用户的问答记录，对线上问句自动分类，聚类发现新知识。'
        }, {
          title: '引导式对话',
          desc: '根据业务流程，引导用户理清复杂问题。'
        }]
      }]
    };
  }
};